import React, { useState, useEffect } from 'react';
import GroupMembers from './GroupMembers';
import FavoriteUnitsCarousel from './FavoriteunitsCarousel';
import ApprovalVotes from './ApprovalVotes';
import GroupChat from './GroupChat';
import JoinRoommateGroup from './JoinRoommateGroup';
import AddRoommateModal from './AddRoommateModal';
import styles from '../../styles/Roommates/RoommateGroupView.module.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;

const RoommateGroupView = ({ tenantId }) => {
  const [groupExists, setGroupExists] = useState(null);
  const [showModal, setShowModal] = useState(false);
  console.log(tenantId);
  useEffect(() => {
    const checkGroupStatus = async () => {
      const res = await fetch(`${API_BASE_URL}/roommates/group/${tenantId}`);
      const data = await res.json();
      setGroupExists(data.groupExists ? data.groupId : null);
    };

    checkGroupStatus();
  }, [tenantId]);

  if (groupExists === null) {
    return (
      <div className={styles.roommateGroupView}>
        <JoinRoommateGroup tenantId={tenantId} refreshGroupStatus={() => setGroupExists(true)} />
      </div>
    );
  }

  return (
    <div className={styles.roommateGroupView}>
      <GroupMembers groupId={groupExists} />
      <FavoriteUnitsCarousel />
      <ApprovalVotes />
      <GroupChat groupId={groupExists} userId={tenantId}/>

      <button className={styles.addRoommateBtn} onClick={() => setShowModal(true)}>
        Add Roommate
      </button>

      {showModal && (
        <AddRoommateModal
          addedByTenantID={tenantId}
          onClose={() => setShowModal(false)}
          onAdded={() => window.location.reload()}
        />
      )}
    </div>
  );
};

export default RoommateGroupView;
